import React , {
  useState,
} from 'react';
import Header from '../../layout/header/header';
import Sidebar from '../../layout/sidebar/sidebar';
import MenuCenter from '../../layout/center/braiding';
import "../../assets/styles/style.css";
function Menu() {
  const [searchTerm, setSearchTerm] = useState(''); 

  const handleSearch = (term) => {
    setSearchTerm(term);
  };
    return (
        <div className='container' >
        <Header placeholder={'Search braid...'} isHomePage={false} onSearch={handleSearch}/>
        <Sidebar/>
        <MenuCenter searchTerm={searchTerm}/> 
      </div>
    );
}

export default Menu;